import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { MIGRATION_COLORS } from '../theme';
import { countyMigration } from '../types';
import type { HoveredCounty } from './MigrationMap';

interface CountyTooltipProps {
  hovered: HoveredCounty | null;
  year: number;
}

export default function CountyTooltip({ hovered, year }: CountyTooltipProps) {
  if (!hovered) return null;

  const { props, x, y } = hovered;
  const value = countyMigration(props, year);
  const color = value > 0 ? MIGRATION_COLORS.positive : MIGRATION_COLORS.negative;
  const sign = value > 0 ? '+' : '';
  const rate =
    props.population > 0 ? ((value / props.population) * 1000).toFixed(1) : undefined;

  return (
    <Paper
      elevation={4}
      sx={{
        position: 'absolute',
        left: x + 14,
        top: y + 14,
        p: 1.25,
        pointerEvents: 'none',
        maxWidth: 260,
        zIndex: 5,
      }}
    >
      <Stack spacing={0.25}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {props.county}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {props.state}
        </Typography>
        <Typography variant="body2" sx={{ color, fontWeight: 700, pt: 0.5 }}>
          {sign}
          {value.toLocaleString()} net domestic migrants ({year})
        </Typography>
        {rate !== undefined && (
          <Typography variant="caption" color="text.secondary">
            {rate} per 1,000 residents · pop. {props.population.toLocaleString()}
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
